import './componentsCss/scroll.css';

export default function ScrollDown() {
    return (
        <div className="scroll-down">
            <img className="scroll-img" src="./assets/scroll.gif" alt="Scroll Down" />
            {/* <p>Scroll down for more</p> */}
        </div>
    )
}